import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const PageOptionType = ApplicationRecord.extend({
  static: {
    jsonapiType: 'page_option_types',
  },
  attrs: {
    name: attr(),
    pageTypeId: attr(),
    description: attr(),
    pageType: belongsTo(),
    pageOptions: hasMany(),
  },
})

export default PageOptionType
